import React from 'react';
import leaderImage from '../img/our-team/ASHA.png';  // Import the image file
import BoardOfDirectorsnavbar from './BoardOfDirectorsnavbar';


const Leadershipdatathree = () => {
    return (
        <div>
            {/* <BoardOfDirectorsnavbar />    */}
            <div style={styles.rowWrapper}>

                <div style={styles.row}>
                    <div style={styles.widgetSpan}>
                        <div id="hs_cos_wrapper_module_1564397675620228" style={styles.hsCosWrapper}>
                            {/* LazySizes Script */}
                            <script src="https://cdnjs.cloudflare.com/ajax/libs/lazysizes/5.3.2/lazysizes.min.js" async=""></script>

                            <div style={styles.abMembers}>
                                <div style={styles.container}>
                                    <div style={styles.imageColumn}>
                                        <div style={styles.mImage}>
                                            {/* Use the imported image */}
                                            <img
                                                className="ls-is-cached lazyloaded"
                                                src={leaderImage}  // Use the imported image here
                                                alt="BVRMOHAN"
                                                style={styles.image}
                                            />
                                        </div>
                                    </div>
                                    <div style={styles.textColumn}>
                                        <h1>ASHA JYOTHI G</h1>
                                        <span>Chef Clients Relations Officer</span>



                                    </div>
                                </div>
                            </div>

                            <div style={styles.memberParagraph}>
                                <div style={styles.container}>
                                    <div style={styles.col12}>
                                        <div style={styles.teamParagraph}>
                                            <p style={{ textAlign: 'justify' }}>
                                                As Chef Clients Relations Officer, ASHA JYOTHI G contributes to the organization’s global brand and purpose.
                                                Mohan acts as a sounding board, mentor, and critic in the spirit of enabling sustainable growth,
                                                especially in matters related to strategy, values, policy, CSR, and government relations.
                                            </p>
                                            <p style={{ textAlign: 'justify' }}>
                                                ASHA JYOTHI G founded Envision (earlier, Infotech Enterprises) in 1991, with the vision of providing engineering services
                                                to global markets. He established the “Engineered in India” brand and led Envision to contribute more than $5 billion
                                                in cumulative exports to several international customers, including many Fortune 100 companies.
                                            </p>
                                            <p style={{ textAlign: 'justify' }}>
                                                ASHA JYOTHI G served as Chairman of NASSCOM in 2015-16 and has been a member of its Executive Council since 2003, and continues
                                                to shape the industry agenda. He served as the Chairman of CII, Southern Region, in 2008-2009 and currently serves
                                                as the National Education Council Chairman. Mohan is also the Founding Director of T-Hub, the largest start-up incubation
                                                center in India.
                                            </p>
                                            <p style={{ textAlign: 'justify' }}>
                                                ASHA JYOTHI G has taken up several leadership positions to promote higher education. At present, he is the Chairman of the Board
                                                of Governors of IIT Hyderabad and IIT Roorkee. He is a member of the Leadership Advisory Board (LAB) at the University
                                                of Michigan College of Engineering, USA, and a member of the Court of Governors of Administrative Staff College of India (ASCI).
                                                Mohan received the Padma Shri, India’s fourth-highest civilian award, in 2017 for his contribution to trade and industry.
                                            </p>
                                            <p style={{ textAlign: 'justify' }}>
                                                ASHA JYOTHI G holds postgraduate degrees in engineering from IIT Kanpur and the University of Michigan, USA. He is the recipient
                                                of honorary doctorates from JNTU Hyderabad, JNTU Kakinada, Andhra University, and KL University.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const styles = {
    rowWrapper: {
        display: 'flex',
        justifyContent: 'center',
        padding: '20px 0',
        marginTop: '46px',
    },
    row: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        maxWidth: '1200px',
    },
    widgetSpan: {
        padding: '20px',
    },
    hsCosWrapper: {
        marginBottom: '30px',
    },
    abMembers: {
        display: 'flex',
        flexDirection: 'row',
        marginBottom: '20px',
    },
    container: {
        display: 'flex',
        width: '100%',
        flexWrap: 'wrap',
    },
    imageColumn: {
        flex: 1,
        paddingRight: '20px',
    },
    mImage: {
        width: '100%',
    },
    image: {
        width: '100%',
        borderRadius: '8px',
    },
    textColumn: {
        flex: 2,
        paddingLeft: '20px',
        display: 'flex',               // Add display flex to enable flexbox layout
        flexDirection: 'column',       // Arrange children in a column
        justifyContent: 'center',     // Vertically center the content
        alignItems: 'center',         // Horizontally center the content
        textAlign: 'center',          // Optional: to ensure the text inside is centered
    },
    socialLink: {
        display: 'inline-block',
        marginTop: '10px',
    },
    socialIcon: {
        width: '30px',
        height: '30px',
    },
    memberParagraph: {
        padding: '20px',
    },
    col12: {
        width: '100%',
    },
    teamParagraph: {
        fontSize: '16px',
        lineHeight: '1.6',
        color: '#333',
        textAlign: 'justify',  // Added text alignment as justify
    },
};

export default Leadershipdatathree;
